import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import {
  AdminBlogShell,
  AdminListPagination,
  AdminListToolbar,
  AdminPageHeader,
  usePreservedDomainSearch,
} from './AdminBlogListPage';
import { LoadingSpinner } from '../../../shared/ui';
import { appendYowanPreviewQueryIfNeeded } from '../../../app/host/yowanPreviewRouting';
import {
  canReactivateYowanSeminarRecord,
  fetchYowanAdminClassList,
  fetchYowanAdminSeminarList,
  fetchYowanAdminSeminarSeriesDetail,
  fetchYowanAdminSeminarSeriesList,
  getYowanAdminPublicVisibilityStatusUi,
  getYowanPublicVisibilityMessages,
  getYowanPublicVisibilityStatusUi,
  getYowanSeminarSlotWarningIssues,
  getYowanSeriesAdminWarningIssues,
} from '../app/yowanContentClient';
const { yowanPageContent } = require('./pageContent');

const EVENTS_PAGE_SIZE = 30;
const eventSortOptions = [
  { value: 'updated-desc', label: '更新日が新しい順' },
  { value: 'published-status', label: '公開ステータス順' },
  { value: 'active-status', label: '有効状態順' },
  { value: 'event-type-asc', label: '種別昇順' },
  { value: 'event-type-desc', label: '種別降順' },
  { value: 'title-asc', label: 'タイトル昇順' },
  { value: 'title-desc', label: 'タイトル降順' },
];

const seminarSortOptions = [
  { value: 'created-desc', label: '作成日が新しい順' },
  { value: 'updated-desc', label: '更新日が新しい順' },
  { value: 'published-status', label: '公開ステータス順' },
  { value: 'active-status', label: '有効状態順' },
  { value: 'title-asc', label: 'セミナー昇順' },
  { value: 'title-desc', label: 'セミナー降順' },
];

const seriesSortOptions = [
  { value: 'created-desc', label: '作成日が新しい順' },
  { value: 'updated-desc', label: '更新日が新しい順' },
  { value: 'published-status', label: '公開ステータス順' },
  { value: 'active-status', label: '有効状態順' },
  { value: 'title-asc', label: 'シリーズ名昇順' },
  { value: 'title-desc', label: 'シリーズ名降順' },
];

const classSortOptions = [
  { value: 'updated-desc', label: '更新日が新しい順' },
  { value: 'published-status', label: '公開ステータス順' },
  { value: 'active-status', label: '有効状態順' },
  { value: 'instructor-asc', label: '講師昇順' },
  { value: 'instructor-desc', label: '講師降順' },
  { value: 'title-asc', label: '教室昇順' },
  { value: 'title-desc', label: '教室降順' },
];

const titleColumnStyle = {
  width: '18rem',
  minWidth: '18rem',
};

const instructorColumnStyle = {
  width: '10rem',
  minWidth: '10rem',
};

const countColumnStyle = {
  width: '7rem',
  minWidth: '7rem',
};

const participantColumnStyle = {
  width: '16rem',
  minWidth: '16rem',
};

const seriesApplicationsColumnStyle = {
  width: '8rem',
  minWidth: '8rem',
  whiteSpace: 'nowrap',
};

const seriesSeminarsColumnStyle = {
  width: '7rem',
  minWidth: '7rem',
  whiteSpace: 'nowrap',
};

const classApplicationColumnStyle = {
  width: '8rem',
  minWidth: '8rem',
};

const participantLinkStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '1.8rem',
  padding: '0.24rem 0.72rem',
  borderRadius: '999px',
  background: 'rgba(116, 126, 115, 0.16)',
  color: '#2f363d',
  fontWeight: 600,
  textDecoration: 'none',
};

const participantSummaryStyle = {
  display: 'grid',
  gap: '0.5rem',
};

const participantTotalStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '0.5rem',
};

const participantTotalLabelStyle = {
  color: 'rgba(47, 54, 61, 0.72)',
  fontSize: '0.72rem',
  fontWeight: 700,
};

const participantSlotBlockStyle = {
  display: 'grid',
  gap: '0.28rem',
};

const participantSlotHeadingStyle = {
  margin: 0,
  color: '#7c2a2e',
  fontSize: '0.74rem',
  fontWeight: 800,
  lineHeight: 1.25,
};

const participantSlotListStyle = {
  display: 'grid',
  gap: '0.22rem',
  margin: 0,
  padding: 0,
  listStyle: 'none',
};

const participantSlotItemStyle = {
  display: 'grid',
  gridTemplateColumns: 'minmax(0, 1fr) auto',
  alignItems: 'center',
  gap: '0.45rem',
  padding: '0.2rem 0.38rem',
  borderRadius: '0.35rem',
  background: 'rgba(116, 126, 115, 0.09)',
  color: 'rgba(47, 54, 61, 0.72)',
  fontSize: '0.75rem',
  lineHeight: 1.35,
};

const participantSlotNameStyle = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

const participantSlotCountStyle = {
  color: '#2f363d',
  fontWeight: 800,
  whiteSpace: 'nowrap',
};

const participantSlotMissingStyle = {
  margin: 0,
  color: 'rgba(47, 54, 61, 0.58)',
  fontSize: '0.74rem',
  lineHeight: 1.35,
};

const locationWarningStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  maxWidth: '100%',
  marginTop: '0.34rem',
  padding: '0.18rem 0.46rem',
  borderRadius: '0.35rem',
  background: 'rgba(171, 102, 25, 0.14)',
  border: '1px solid rgba(171, 102, 25, 0.34)',
  color: '#7a3f0e',
  fontSize: '0.72rem',
  fontWeight: 800,
  lineHeight: 1.25,
};

const warningGroupStyle = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: '0.28rem',
};

const nextSlotColumnStyle = {
  width: '11rem',
  minWidth: '11rem',
};

const seminarNextSlotColumnStyle = {
  width: '15rem',
  minWidth: '15rem',
};

const updatedAtColumnStyle = {
  width: '11.5rem',
  minWidth: '11.5rem',
  whiteSpace: 'nowrap',
};

const actionColumnStyle = {
  width: '14rem',
  minWidth: '14rem',
  whiteSpace: 'nowrap',
};

const seriesActionColumnStyle = {
  width: '16rem',
  minWidth: '16rem',
  whiteSpace: 'nowrap',
};

const stackedActionStyle = {
  alignItems: 'flex-start',
  flexDirection: 'column',
  gap: '0.28rem',
};

const statusToUi = (isEnabled) => ({
  label: isEnabled ? '有効' : '停止中',
  tone: isEnabled ? 'published' : 'draft',
});

const displayEventLabel = (value) => {
  if (!value) {
    return value;
  }

  return String(value)
    .replaceAll('一連の講習会', 'シリーズ')
    .replaceAll('単独講習会', '単独セミナー')
    .replaceAll('Seminar', 'セミナー')
    .replaceAll('Series', 'シリーズ')
    .replaceAll('Class', '教室');
};

const getSeminarSlotParticipantRows = (row = {}) => (
  Array.isArray(row.slots)
    ? row.slots.filter((slot) => slot.hasApplicationsCount)
    : []
);

const getSeminarSlotParticipantLabel = (slot = {}) => (
  [slot.title, slot.datetimeLabel].filter(Boolean).join(' / ') ||
  slot.datetimeLabel ||
  slot.startLabel ||
  slot.id ||
  '-'
);

const getScheduleLocationWarningLabel = (entry = {}) => (
  [entry.scheduleLabel, entry.datetimeLabel].filter(Boolean).join(' / ') ||
  entry.datetimeLabel ||
  entry.scheduleLabel ||
  entry.id ||
  '-'
);

const isExplicitlyInactive = (source = {}) => (
  source === false ||
  source?.isActive === false ||
  source?.is_active === false
);

const getInactiveLocationState = (entry = {}) => ({
  facility: isExplicitlyInactive(entry.facilityIsActive) || isExplicitlyInactive(entry.facility),
  room: isExplicitlyInactive(entry.roomIsActive) || isExplicitlyInactive(entry.room),
});

const getInactiveLocationWarning = (row = {}) => {
  const sourceEntries = Array.isArray(row.slots) && row.slots.length
    ? row.slots.map((entry) => ({ entry, label: getSeminarSlotParticipantLabel(entry) }))
    : Array.isArray(row.schedules)
      ? row.schedules.map((entry) => ({ entry, label: getScheduleLocationWarningLabel(entry) }))
      : [];
  const affectedEntries = sourceEntries
    .map(({ entry, label }) => ({
      ...getInactiveLocationState(entry),
      label,
    }))
    .filter((entry) => entry.facility || entry.room);

  if (!affectedEntries.length) {
    return null;
  }

  const hasInactiveFacility = affectedEntries.some((entry) => entry.facility);
  const hasInactiveRoom = affectedEntries.some((entry) => entry.room);
  const targetLabel = hasInactiveFacility && hasInactiveRoom
    ? '施設/部屋'
    : hasInactiveFacility
      ? '施設'
      : '部屋';
  const slotCountLabel = affectedEntries.length > 1 ? ` ${affectedEntries.length}コマ` : '';
  const affectedLabels = affectedEntries
    .map(({ label }) => label)
    .filter(Boolean)
    .join(' / ');

  return {
    label: `停止中の${targetLabel}あり${slotCountLabel}`,
    title: affectedLabels ? `停止中の${targetLabel}を参照: ${affectedLabels}` : `停止中の${targetLabel}を参照`,
  };
};

const getSchedulePersonWarningLabel = (entry = {}) => (
  [entry.scheduleLabel, entry.datetimeLabel].filter(Boolean).join(' / ') ||
  entry.datetimeLabel ||
  entry.scheduleLabel ||
  entry.title ||
  entry.id ||
  '-'
);

const getInactivePeopleWarning = (row = {}) => {
  const sourceEntries = Array.isArray(row.slots) && row.slots.length
    ? row.slots.map((entry) => ({ entry, label: getSeminarSlotParticipantLabel(entry) }))
    : Array.isArray(row.schedules)
      ? row.schedules.map((entry) => ({ entry, label: getSchedulePersonWarningLabel(entry) }))
      : [];
  const inactiveInstructorEntries = sourceEntries.filter(({ entry }) => (
    isExplicitlyInactive(entry.instructorIsActive) ||
    isExplicitlyInactive(entry.instructor) ||
    isExplicitlyInactive(entry.instructorProfile)
  ));
  const hasInactiveOrganizer = isExplicitlyInactive(row.organizerIsActive) ||
    isExplicitlyInactive(row.organizer) ||
    isExplicitlyInactive(row.series?.organizerIsActive) ||
    isExplicitlyInactive(row.series?.organizer);

  if (!inactiveInstructorEntries.length && !hasInactiveOrganizer) {
    return null;
  }

  const targetLabel = inactiveInstructorEntries.length && hasInactiveOrganizer
    ? '講師/主催者'
    : inactiveInstructorEntries.length
      ? '講師'
      : '主催者';
  const slotCountLabel = inactiveInstructorEntries.length > 1 ? ` ${inactiveInstructorEntries.length}コマ` : '';
  const affectedLabels = inactiveInstructorEntries
    .map(({ label }) => label)
    .filter(Boolean)
    .join(' / ');
  const organizerLabel = row.organizerName || row.series?.organizerName || '';
  const titleParts = [
    inactiveInstructorEntries.length
      ? `停止中の講師を参照${affectedLabels ? `: ${affectedLabels}` : ''}`
      : '',
    hasInactiveOrganizer
      ? `停止中の主催者を参照${organizerLabel ? `: ${organizerLabel}` : ''}`
      : '',
  ].filter(Boolean);

  return {
    label: `停止中の${targetLabel}あり${slotCountLabel}`,
    title: titleParts.join(' / ') || `停止中の${targetLabel}を参照`,
  };
};

const getSeminarSlotWarnings = (row = {}) => (
  row.isActive === false
    ? [{
        label: '全体停止中',
        title: 'セミナー中止/停止により、公開面表示と申込受付を停止しています。再開は運用再開から行います。',
      }]
    : getYowanSeminarSlotWarningIssues(row).map((issue) => ({
        label: issue.label,
        title: issue.message,
      }))
);

const getSeriesWarnings = (row = {}) => (
  getYowanSeriesAdminWarningIssues(row).map((issue) => ({
    label: issue.label,
    title: issue.message,
  }))
);

const getSeriesPublishedCountLabel = (row = {}) => {
  const total = Number(row.seminarsCount ?? row.eventsCount ?? 0);
  const hasPublishedCount = row.hasPublishedSeminarsCount === true ||
    row.publishedSeminarsCount !== undefined ||
    row.publishedEventsCount !== undefined;

  if (total > 0 && hasPublishedCount) {
    const published = Number(row.publishedSeminarsCount ?? row.publishedEventsCount ?? 0);
    return `公開 ${published}/${total}件`;
  }

  if (total > 0) {
    return '公開状況: 詳細で確認';
  }

  return '公開セミナーなし';
};

const sortEventRows = (rows, sortKey) => {
  const nextRows = [...rows];

  nextRows.sort((left, right) => {
    if (sortKey === 'published-status') {
      if (left.isPublished === right.isPublished) {
        return left.title.localeCompare(right.title, 'ja');
      }
      return left.isPublished ? -1 : 1;
    }

    if (sortKey === 'active-status') {
      if (left.isActive === right.isActive) {
        return left.title.localeCompare(right.title, 'ja');
      }
      return left.isActive ? -1 : 1;
    }

    if (sortKey === 'event-type-asc') {
      if (left.eventType === right.eventType) {
        return left.title.localeCompare(right.title, 'ja');
      }
      return left.eventType.localeCompare(right.eventType, 'ja');
    }

    if (sortKey === 'event-type-desc') {
      if (left.eventType === right.eventType) {
        return left.title.localeCompare(right.title, 'ja');
      }
      return right.eventType.localeCompare(left.eventType, 'ja');
    }

    if (sortKey === 'instructor-asc') {
      const leftInstructor = getRowInstructorSortValue(left);
      const rightInstructor = getRowInstructorSortValue(right);

      if (leftInstructor === rightInstructor) {
        return left.title.localeCompare(right.title, 'ja');
      }
      return leftInstructor.localeCompare(rightInstructor, 'ja');
    }

    if (sortKey === 'instructor-desc') {
      const leftInstructor = getRowInstructorSortValue(left);
      const rightInstructor = getRowInstructorSortValue(right);

      if (leftInstructor === rightInstructor) {
        return left.title.localeCompare(right.title, 'ja');
      }
      return rightInstructor.localeCompare(leftInstructor, 'ja');
    }

    if (sortKey === 'title-asc') {
      return left.title.localeCompare(right.title, 'ja');
    }

    if (sortKey === 'title-desc') {
      return right.title.localeCompare(left.title, 'ja');
    }

    const sortDateKey = sortKey === 'created-desc' ? 'createdAt' : 'updatedAt';
    const leftSourceDate = left[sortDateKey] || '';
    const rightSourceDate = right[sortDateKey] || '';
    const leftDate = Date.parse(leftSourceDate.replace(' ', 'T'));
    const rightDate = Date.parse(rightSourceDate.replace(' ', 'T'));
    const safeLeft = Number.isNaN(leftDate) ? 0 : leftDate;
    const safeRight = Number.isNaN(rightDate) ? 0 : rightDate;
    return safeRight - safeLeft;
  });

  return nextRows;
};

const getRowInstructorNames = (row) => {
  const scheduleInstructors = (row.schedules || [])
    .map((schedule) => schedule.instructorName || schedule.instructor?.instructorName || schedule.instructor?.instructor_name)
    .filter(Boolean);
  const slotInstructors = (row.slots || [])
    .map((slot) => slot.instructorName || slot.instructor || slot.instructorProfile?.instructorName || slot.instructorProfile?.instructor_name)
    .filter(Boolean);
  const uniqueInstructors = Array.from(new Set([...scheduleInstructors, ...slotInstructors]));

  if (uniqueInstructors.length) {
    return uniqueInstructors;
  }

  return row.standardInstructor ? [row.standardInstructor] : [];
};

const getRowInstructor = (row) => {
  const instructors = getRowInstructorNames(row);

  if (!instructors.length) {
    return '-';
  }

  if (instructors.length === 1) {
    return instructors[0];
  }

  return `${instructors[0]} 他${instructors.length - 1}名`;
};

const getRowInstructorSearchValue = (row) => {
  const instructors = getRowInstructorNames(row);
  return instructors.join(' ');
};

const getRowInstructorSortValue = (row) => {
  const instructors = getRowInstructorNames(row);
  return instructors[0] || '';
};

const AdminEventsListPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const contentKey = location.pathname === '/admin/events/seminars' || location.pathname === '/admin/events/classes'
    ? location.pathname
    : null;
  const content = yowanPageContent[contentKey];
  const isClassList = contentKey === '/admin/events/classes';
  const isSeminarList = contentKey === '/admin/events/seminars';
  const activeTab = new URLSearchParams(location.search).get('tab') || 'seminars';
  const isSeriesTab = isSeminarList && activeTab === 'series';
  const defaultSortKey = isSeminarList ? 'created-desc' : 'updated-desc';
  const preservedDomainSearch = usePreservedDomainSearch();
  const [searchQuery, setSearchQuery] = useState('');
  const [sortKey, setSortKey] = useState(defaultSortKey);
  const [currentPage, setCurrentPage] = useState(1);
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [loadError, setLoadError] = useState('');

  useEffect(() => {
    setSortKey(defaultSortKey);
    setCurrentPage(1);
  }, [defaultSortKey]);

  useEffect(() => {
    let isMounted = true;

    if (!contentKey) {
      return () => {
        isMounted = false;
      };
    }

    setIsLoading(true);
    setLoadError('');

    const request = isSeriesTab
      ? fetchYowanAdminSeminarSeriesList({ pageSize: EVENTS_PAGE_SIZE, isActive: 'all' })
      : isClassList
      ? fetchYowanAdminClassList({ pageSize: EVENTS_PAGE_SIZE, isActive: 'all' })
      : fetchYowanAdminSeminarList({ pageSize: EVENTS_PAGE_SIZE, isActive: 'all' });

    request
      .then(async (payload) => {
        if (!isMounted) {
          return;
        }

        if (!isSeriesTab) {
          setRows(payload.results);
          return;
        }

        const enrichedRows = await Promise.all(
          (payload.results || []).map(async (row) => {
            if (!row?.id) {
              return row;
            }

            try {
              const detail = await fetchYowanAdminSeminarSeriesDetail(row.id);
              return {
                ...row,
                seminars: detail?.seminars || row.seminars || [],
                publicVisibility: detail?.publicVisibility || row.publicVisibility,
                isActive: detail?.isActive ?? row.isActive,
                isPublished: detail?.isPublished ?? row.isPublished,
                seminarsCount: detail?.seminarsCount ?? row.seminarsCount,
                eventsCount: detail?.eventsCount ?? row.eventsCount,
                publishedSeminarsCount: detail?.publishedSeminarsCount ?? row.publishedSeminarsCount,
                hasPublishedSeminarsCount: detail?.hasPublishedSeminarsCount ?? row.hasPublishedSeminarsCount,
              };
            } catch (error) {
              return row;
            }
          }),
        );

        if (isMounted) {
          setRows(enrichedRows);
        }
      })
      .catch(() => {
        if (!isMounted) {
          return;
        }

        setRows([]);
        setLoadError('教室・セミナー情報を読み込めませんでした。時間をおいて再度お試しください。');
      })
      .finally(() => {
        if (isMounted) {
          setIsLoading(false);
        }
      });

    return () => {
      isMounted = false;
    };
  }, [contentKey, isClassList, isSeriesTab]);

  if (!content) {
    return null;
  }

  const normalizedQuery = searchQuery.trim().toLowerCase();
  const filteredRows = normalizedQuery
    ? rows.filter((row) => {
        const defaultSearchKeys = [
          row.title,
          row.eventTypeLabel,
          row.isPublished ? '公開中' : '非公開',
          row.isActive ? 'active' : 'inactive',
          row.nextSlotLabel,
          getRowInstructorSearchValue(row),
          row.seriesKindLabel,
          row.series?.title,
          row.organizerName,
          ...(row.seminars || []).map((seminar) => seminar.title),
        ];
        const rowSearchKeys = content.searchKeys
          ? [...content.searchKeys, ...defaultSearchKeys]
          : defaultSearchKeys;

        return rowSearchKeys
          .map((value) => (typeof value === 'function' ? value(row) : value))
          .filter(Boolean)
          .some((value) => value.toLowerCase().includes(normalizedQuery));
      })
    : rows;
  const sortedRows = sortEventRows(filteredRows, sortKey);
  const totalPages = Math.max(1, Math.ceil(sortedRows.length / EVENTS_PAGE_SIZE));
  const safeCurrentPage = Math.min(currentPage, totalPages);
  const startIndex = (safeCurrentPage - 1) * EVENTS_PAGE_SIZE;
  const visibleRows = sortedRows.slice(startIndex, startIndex + EVENTS_PAGE_SIZE);
  const showChildManagement = !isSeriesTab && content.showChildManagement !== false;
  const showTypeColumn = !isSeriesTab && content.showTypeColumn !== false;
  const showInstructorColumn = !isSeriesTab && content.showInstructorColumn === true;
  const showParticipantsColumn = !isSeriesTab && content.showParticipantsColumn === true;
  const showClassApplicationsColumn = content.showClassApplicationsColumn === true;
  const baseSortOptions = content.sortOptions || (
    showInstructorColumn
      ? classSortOptions
      : showTypeColumn
        ? eventSortOptions
        : seminarSortOptions
  );
  const sortOptions = isSeriesTab
    ? seriesSortOptions
    : isSeminarList
      ? [
          seminarSortOptions[0],
          ...baseSortOptions.filter((option) => option.value !== seminarSortOptions[0].value),
        ]
      : baseSortOptions;
  const dateTimeColumnStyle = isSeminarList ? seminarNextSlotColumnStyle : nextSlotColumnStyle;
  const searchPlaceholder = isSeriesTab
    ? 'シリーズ名 / 主催者 / セミナー / 公開 / 有効'
    : content.searchPlaceholder || (
      showInstructorColumn
        ? '教室 / 講師 / 公開 / 有効'
        : 'タイトル / 種別 / 公開 / 有効 / 次回開催'
    );
  const buildDuplicateHref = (row) => {
    const searchParams = new URLSearchParams(location.search);

    searchParams.set('duplicateFrom', row.id);

    return appendYowanPreviewQueryIfNeeded(`/admin/events/new?${searchParams.toString()}`, location.search);
  };
  const buildSeriesDuplicateHref = (row) => {
    const searchParams = new URLSearchParams(location.search);

    searchParams.delete('tab');
    searchParams.delete('duplicateFrom');
    searchParams.delete('seriesId');
    searchParams.set('duplicateSeriesFrom', row.id);

    return appendYowanPreviewQueryIfNeeded(`/admin/events/new?${searchParams.toString()}`, location.search);
  };

  return (
    <AdminBlogShell activeNavHref={content.activeNavHref || contentKey} routeKey={content.routeKey || contentKey}>
      <AdminPageHeader
        title={content.header.title}
        paragraphs={content.header.paragraphs}
        actions={[
          <Link
            key="primary-action"
            className="c-form__submit"
            to={appendYowanPreviewQueryIfNeeded(content.primaryAction.href, preservedDomainSearch)}
          >
            {content.primaryAction.label}
          </Link>,
        ]}
      />

      {isSeminarList ? (
        <div className="yowan-admin-tabs" role="tablist" aria-label="セミナー表示">
          <button
            type="button"
            className={`yowan-admin-tabs__tab${!isSeriesTab ? ' yowan-admin-tabs__tab--active' : ''}`}
            aria-selected={!isSeriesTab}
            role="tab"
            onClick={() => {
              const params = new URLSearchParams(location.search);
              params.delete('tab');
              const nextSearch = params.toString();
              navigate(`${location.pathname}${nextSearch ? `?${nextSearch}` : ''}`);
            }}
          >
            セミナー
          </button>
          <button
            type="button"
            className={`yowan-admin-tabs__tab${isSeriesTab ? ' yowan-admin-tabs__tab--active' : ''}`}
            aria-selected={isSeriesTab}
            role="tab"
            onClick={() => {
              const params = new URLSearchParams(location.search);
              params.set('tab', 'series');
              navigate(`${location.pathname}?${params.toString()}`);
            }}
          >
            シリーズ
          </button>
        </div>
      ) : null}

      <AdminListToolbar
        searchValue={searchQuery}
        onSearchChange={(event) => {
          setSearchQuery(event.target.value);
          setCurrentPage(1);
        }}
        sortValue={sortKey}
        onSortChange={(event) => {
          setSortKey(event.target.value);
          setCurrentPage(1);
        }}
        metaText={`${sortedRows.length}件中 ${visibleRows.length}件を表示${
          totalPages > 1 ? ` / ${safeCurrentPage} / ${totalPages}ページ` : ''
        }`}
        searchPlaceholder={searchPlaceholder}
        sortOptions={sortOptions}
      />

      <div className="yowan-admin-resource-table-wrap c-surface-content">
        {isLoading ? (
          <LoadingSpinner label="教室・セミナー情報を読み込み中" showLabel />
        ) : null}
        {!isLoading && loadError ? (
          <p className="yowan-admin-form__message">{loadError}</p>
        ) : null}
        {!isLoading && !loadError && !visibleRows.length ? (
          <p className="yowan-admin-form__message">該当するデータはありません。</p>
        ) : null}
        {!isLoading && !loadError && visibleRows.length && isSeriesTab ? (
          <table className="yowan-admin-resource-table">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col" style={titleColumnStyle}>シリーズ名</th>
                <th scope="col" style={seriesSeminarsColumnStyle}>セミナー</th>
                <th scope="col" style={seriesApplicationsColumnStyle}>申込者</th>
                <th scope="col">{showParticipantsColumn ? '公開面' : '公開'}</th>
                <th scope="col">有効</th>
                <th scope="col" style={updatedAtColumnStyle}>更新日</th>
                <th scope="col" style={seriesActionColumnStyle}>操作</th>
              </tr>
            </thead>
            <tbody>
              {visibleRows.map((row, index) => {
                const activeUi = statusToUi(row.isActive);
                const seriesWarnings = getSeriesWarnings(row);

                return (
                  <tr key={row.id}>
                    <td>{startIndex + index + 1}</td>
                    <td style={titleColumnStyle}>
                      <p className="yowan-admin-resource-table__title">
                        <Link to={appendYowanPreviewQueryIfNeeded(row.detailHref, preservedDomainSearch)}>
                          {row.title || '-'}
                        </Link>
                      </p>
                      <p className="yowan-admin-resource-table__subline">{row.subtitle || row.organizerName || '-'}</p>
                      {seriesWarnings.length ? (
                        <div style={warningGroupStyle}>
                          {seriesWarnings.map((warning) => (
                            <span key={warning.label} style={locationWarningStyle} title={warning.title}>
                              {warning.label}
                            </span>
                          ))}
                        </div>
                      ) : null}
                    </td>
                    <td style={seriesSeminarsColumnStyle}>
                      <p className="yowan-admin-resource-table__title">{row.seminarsCount || row.eventsCount || 0}件</p>
                      <p className="yowan-admin-resource-table__subline">{getSeriesPublishedCountLabel(row)}</p>
                    </td>
                    <td style={seriesApplicationsColumnStyle}>{row.applicationsCount || 0}名</td>
                    <td>
                      <span
                        className={`yowan-admin-resource-table__status yowan-admin-resource-table__status--${
                          row.isPublished ? 'published' : 'draft'
                        }`}
                      >
                        {row.isPublished ? '公開中' : '非公開'}
                      </span>
                    </td>
                    <td>
                      <span className={`yowan-admin-resource-table__status yowan-admin-resource-table__status--${activeUi.tone}`}>
                        {activeUi.label}
                      </span>
                    </td>
                    <td style={updatedAtColumnStyle}>{row.updatedAt || '-'}</td>
                    <td style={seriesActionColumnStyle}>
                      <div className="yowan-admin-resource-table__actions" style={stackedActionStyle}>
                        <Link to={appendYowanPreviewQueryIfNeeded(row.detailHref, preservedDomainSearch)}>詳細</Link>
                        <Link to={appendYowanPreviewQueryIfNeeded(row.editHref, preservedDomainSearch)}>編集</Link>
                        <Link to={appendYowanPreviewQueryIfNeeded(`/admin/events/series/${row.id}/application-messages`, preservedDomainSearch)}>メッセージ</Link>
                        <Link to={appendYowanPreviewQueryIfNeeded(row.addSeminarHref, preservedDomainSearch)}>セミナー追加</Link>
                        <Link to={buildSeriesDuplicateHref(row)}>シリーズ複製</Link>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        ) : null}
        {!isLoading && !loadError && visibleRows.length && !isSeriesTab ? (
          <table className="yowan-admin-resource-table">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col" style={titleColumnStyle}>{content.titleColumnLabel || 'タイトル'}</th>
                {showParticipantsColumn ? (
                  <th scope="col" style={participantColumnStyle}>参加者</th>
                ) : null}
                {showClassApplicationsColumn ? (
                  <th scope="col" style={classApplicationColumnStyle}>申込者</th>
                ) : null}
                {showInstructorColumn ? <th scope="col" style={instructorColumnStyle}>講師</th> : null}
                {showTypeColumn ? <th scope="col">種別</th> : null}
                {showChildManagement ? (
                  <th scope="col" style={dateTimeColumnStyle}>{content.dateTimeColumnLabel || '次回開催'}</th>
                ) : null}
                {showChildManagement ? <th scope="col" style={countColumnStyle}>{content.slotCountColumnLabel || 'コマ'}</th> : null}
                {!showParticipantsColumn && !showClassApplicationsColumn && showChildManagement ? (
                  <th scope="col" style={countColumnStyle}>申込</th>
                ) : null}
                <th scope="col">公開</th>
                <th scope="col">有効</th>
                <th scope="col" style={updatedAtColumnStyle}>更新日</th>
                <th scope="col" style={actionColumnStyle}>操作</th>
              </tr>
            </thead>
            <tbody>
              {visibleRows.map((row, index) => {
                const activeUi = statusToUi(row.isActive);
                const slotParticipantRows = showParticipantsColumn ? getSeminarSlotParticipantRows(row) : [];
                const adminWarnings = (showParticipantsColumn || showClassApplicationsColumn)
                  ? [
                      getInactiveLocationWarning(row),
                      getInactivePeopleWarning(row),
                      ...(showParticipantsColumn ? getSeminarSlotWarnings(row) : []),
                    ].filter(Boolean)
                  : [];
                const seriesWarnings = isSeriesTab ? getSeriesWarnings(row) : [];
                const titleWarnings = [...adminWarnings, ...seriesWarnings];
                const publicVisibilityUi = showParticipantsColumn
                  ? getYowanAdminPublicVisibilityStatusUi(row.publicVisibility)
                  : getYowanPublicVisibilityStatusUi(row.publicVisibility);

                return (
                  <tr key={row.id}>
                    <td>{startIndex + index + 1}</td>
                    <td style={titleColumnStyle}>
                      <p className="yowan-admin-resource-table__title">
                        {showParticipantsColumn ? (
                          <Link to={appendYowanPreviewQueryIfNeeded(row.detailHref || row.editHref, preservedDomainSearch)}>
                            {row.title}
                          </Link>
                        ) : row.title}
                      </p>
                      {showParticipantsColumn && row.seriesKind === 'grouped' ? (
                        <p className="yowan-admin-resource-table__subline">
                          {displayEventLabel(row.seriesKindLabel)}: {row.series?.title || '-'}
                        </p>
                      ) : null}
                      {titleWarnings.length ? (
                        <div style={warningGroupStyle}>
                          {titleWarnings.map((warning) => (
                            <span key={warning.label} style={locationWarningStyle} title={warning.title}>
                              {warning.label}
                            </span>
                          ))}
                        </div>
                      ) : null}
                      <p className="yowan-admin-resource-table__subline">{row.summary || '-'}</p>
                    </td>
                    {showParticipantsColumn ? (
                      <td style={participantColumnStyle}>
                        <div style={participantSummaryStyle}>
                          <div style={participantTotalStyle}>
                            <span style={participantTotalLabelStyle}>合計</span>
                            <Link style={participantLinkStyle} to={appendYowanPreviewQueryIfNeeded(row.applicationsHref, preservedDomainSearch)}>
                              {row.applicationsCount || 0}名
                            </Link>
                          </div>
                          <div style={participantSlotBlockStyle}>
                            <p style={participantSlotHeadingStyle}>コマ別</p>
                            {slotParticipantRows.length ? (
                              <ul style={participantSlotListStyle}>
                                {slotParticipantRows.slice(0, 4).map((slot) => (
                                  <li key={slot.id || getSeminarSlotParticipantLabel(slot)} style={participantSlotItemStyle}>
                                    <span style={participantSlotNameStyle}>{getSeminarSlotParticipantLabel(slot)}</span>
                                    <span style={participantSlotCountStyle}>{slot.applicationsCount || 0}名</span>
                                  </li>
                                ))}
                                {slotParticipantRows.length > 4 ? (
                                  <li style={participantSlotItemStyle}>
                                    <span style={participantSlotNameStyle}>ほか</span>
                                    <span style={participantSlotCountStyle}>{slotParticipantRows.length - 4}コマ</span>
                                  </li>
                                ) : null}
                              </ul>
                            ) : (
                              <p style={participantSlotMissingStyle}>未取得</p>
                            )}
                          </div>
                        </div>
                      </td>
                    ) : null}
                    {showClassApplicationsColumn ? (
                      <td style={classApplicationColumnStyle}>
                        <Link
                          style={participantLinkStyle}
                          to={appendYowanPreviewQueryIfNeeded(`/admin/events/classes/${row.id}/applications`, preservedDomainSearch)}
                        >
                          {row.applicationsCount || 0}名
                        </Link>
                      </td>
                    ) : null}
                    {showInstructorColumn ? (
                      <td style={instructorColumnStyle} title={getRowInstructorSearchValue(row)}>
                        {getRowInstructor(row)}
                      </td>
                    ) : null}
                    {showTypeColumn ? <td>{displayEventLabel(row.eventTypeLabel)}</td> : null}
                    {showChildManagement ? <td style={dateTimeColumnStyle}>{row.nextSlotLabel || '-'}</td> : null}
                    {showChildManagement ? <td style={countColumnStyle}>{row.slotsCount || row.schedulesCount}</td> : null}
                    {!showParticipantsColumn && !showClassApplicationsColumn && showChildManagement ? (
                      <td style={countColumnStyle}>{row.applicationsCount}</td>
                    ) : null}
                    <td>
                      <span
                        className={`yowan-admin-resource-table__status yowan-admin-resource-table__status--${
                          showParticipantsColumn
                            ? publicVisibilityUi.tone
                            : row.isPublished ? 'published' : 'draft'
                        }`}
                        title={showParticipantsColumn ? getYowanPublicVisibilityMessages(row.publicVisibility).join(' / ') : undefined}
                      >
                        {showParticipantsColumn
                          ? publicVisibilityUi.label
                          : row.isPublished ? '公開中' : '非公開'}
                      </span>
                    </td>
                    <td>
                      <span className={`yowan-admin-resource-table__status yowan-admin-resource-table__status--${activeUi.tone}`}>
                        {activeUi.label}
                      </span>
                    </td>
                    <td style={updatedAtColumnStyle}>{row.updatedAt || '-'}</td>
                    <td style={actionColumnStyle}>
                      <div className="yowan-admin-resource-table__actions">
                        {showParticipantsColumn ? (
                          <Link to={appendYowanPreviewQueryIfNeeded(row.detailHref || row.editHref, preservedDomainSearch)}>詳細</Link>
                        ) : null}
                        <Link to={appendYowanPreviewQueryIfNeeded(row.editHref, preservedDomainSearch)}>編集</Link>
                        {showParticipantsColumn ? (
                          <Link to={appendYowanPreviewQueryIfNeeded(`/admin/events/${row.id}/application-messages`, preservedDomainSearch)}>
                            メッセージ
                          </Link>
                        ) : null}
                        {showParticipantsColumn ? (
                          <Link to={buildDuplicateHref(row)}>複製</Link>
                        ) : null}
                        {showParticipantsColumn && row.isActive !== false ? (
                          <Link to={appendYowanPreviewQueryIfNeeded(row.cancelHref || `/admin/events/${row.id}/cancel`, preservedDomainSearch)}>
                            中止
                          </Link>
                        ) : null}
                        {showParticipantsColumn && canReactivateYowanSeminarRecord(row) ? (
                          <Link to={appendYowanPreviewQueryIfNeeded(row.reactivateHref || `/admin/events/${row.id}/reactivate`, preservedDomainSearch)}>
                            運用再開
                          </Link>
                        ) : null}
                        {showClassApplicationsColumn ? (
                          <Link to={appendYowanPreviewQueryIfNeeded(`/admin/events/classes/${row.id}/applications`, preservedDomainSearch)}>
                            申込者
                          </Link>
                        ) : null}
                        {showChildManagement && !showParticipantsColumn ? (
                          <Link to={appendYowanPreviewQueryIfNeeded(row.slotsHref, preservedDomainSearch)}>コマ</Link>
                        ) : null}
                        {showChildManagement && !showParticipantsColumn && !showClassApplicationsColumn ? (
                          <Link to={appendYowanPreviewQueryIfNeeded(row.applicationsHref, preservedDomainSearch)}>申込</Link>
                        ) : null}
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        ) : null}
      </div>

      <AdminListPagination
        currentPage={safeCurrentPage}
        totalPages={totalPages}
        onPageChange={setCurrentPage}
      />
    </AdminBlogShell>
  );
};

export default AdminEventsListPage;
